<template>
  <v-card>
    <v-icon class="close" @click="$emit('close')">$sl-close</v-icon>
    <v-card-title v-if="wp.name">
      <span class="display-1">Ändra arbetsplats</span>
    </v-card-title>
    <v-card-title v-else>
      <span class="display-1">LÄGG TILL ARBETSPLATS</span>
    </v-card-title>

    <v-card-text>
      <v-form ref="form">
        <v-row no-gutters>
          <v-col cols="12" sm="12" md="12">
            <v-text-field
              data-cy="wp-name"
              outlined
              :rules="[rules.required]"
              v-model="wp.name"
              label="Arbetsplatsens namn"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <address-box
              ref="addressbox"
              :address="useraddress"
              :hasCountry="true"
              :borderless="true"
              @changed="updateAddress"
              :show="false"
              :showTextArea="true"
            />
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" sm="12" md="12">
            <v-text-field data-cy="wp-phone" outlined v-model="wp.phone" label="Telefonnummer"></v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" sm="12" md="12">
            <v-text-field
              outlined
              data-cy="wp-email"
              v-model="wp.email"
              :rules="[rules.email]"
              label="E-postadress"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-text-field outlined data-cy="wp-web" v-model="wp.web" label="Webbplats"></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="selectedCompany && selectedCompany.hasDepartments">
          <v-col cols="12" sm="12" md="12" class="mt-n3">
            <MultiSelect ref="multiSelect" :list="departments" label="Avdelningar" v-model="wp.departmentIds" />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="1">
            <v-switch class="pt-0 mt-0" v-model="wp.isInvoiceWorkplace"></v-switch>
          </v-col>
          <v-col cols="11" class="pl-5">
            <h6 class="switch">FAKTURERINGSADRESS</h6>
            <template v-if="wp.isInvoiceWorkplace">
              <v-row no-gutters dense class="title-icon mt-n2">
                <v-col>
                  <p>Denna arbetsplats är en faktureringsadress för beställningar</p>
                </v-col>
              </v-row>
              <v-text-field
                class="mt-n1"
                outlined
                label="Attention för fakturor"
                v-model="wp.invoiceAddressAttention"
              />
              <v-text-field class="mt-n1" outlined label="E-postadress för fakturor" v-model="wp.invoiceAddressEmail" />
              <p class="caption mt-n4">
                Om e-postadress finns angiven kommer fakturor att skickas digitalt till e-postadressen och inte med
                post.
              </p>
            </template>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="1">
            <v-switch class="pt-0 mt-0" v-model="wp.isDeliveryWorkplace"></v-switch>
          </v-col>
          <v-col cols="11" class="pl-5">
            <h6 class="switch">LEVERANSADRESS</h6>
            <template v-if="wp.isDeliveryWorkplace">
              <v-row no-gutters dense class="title-icon mt-n2">
                <v-col>
                  <p>Denna arbetsplats är en leveransadress för beställningar</p>
                </v-col>
              </v-row>
              <v-text-field
                class="mt-n1"
                outlined
                label="Attention för leveranser"
                v-model="wp.deliveryAddressAttention"
              />
              <v-text-field
                outlined
                data-cy="deliveryPhone"
                v-model="wp.deliveryPhone"
                label="Telefonnummer"
                :rules="wp.isDeliveryWorkplace ? [rules.required, rules.phone] : undefined"
              />
            </template>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-card-actions class="justify-end">
      <v-btn data-cy="cancel-workplace" color="secondary" @click="$emit('close')">
        <v-icon>$sl-cancel</v-icon>Avbryt
      </v-btn>
      <v-btn data-cy="save-workplace" @click="save()"> <v-icon>$sl-check</v-icon>Spara </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import {mapGetters, mapActions} from 'vuex'
import {RulesMixin} from '@/components/mixins'
import AddressBox from '@/components/AddressBox.vue'
import MultiSelect from '@/components/common/SelectTypes/MultiSelect'
// @group Company
// Styled PersonNewModal component
export default {
  name: 'CompanyWorkplaceModal',

  props: {
    //has workplace object
    wp: Object,
    reRender: {
      type: Boolean,
      default: false
    }
  },

  mixins: [RulesMixin],

  components: {
    AddressBox,
    MultiSelect
  },
  data() {
    return {
      departments: []
    }
  },
  watch: {
    reRender(newValue, oldValue) {
      this.getDepartments()
    }
  },
  created() {
    this.getDepartments()
  },
  computed: {
    ...mapGetters('company', ['selectedCompany']),
    //- Uset to get and set data from AddressBox component

    useraddress: {
      get: function () {
        return {
          address1: this.wp.postalAddress1,
          address2: this.wp.postalAddress2,
          zip: this.wp.postalZip,
          city: this.wp.postalCity,
          country: this.wp.postalCountry
        }
      },
      // setter
      set: function (newAddress) {
        this.wp.postalAddress1 = newAddress.address1
        this.wp.postalAddress2 = newAddress.address2
        this.wp.postalZip = newAddress.zip
        this.wp.postalCity = newAddress.city
        this.wp.postalCountry = newAddress.country
      }
    }
  },
  methods: {
    updateAddress(newAddress) {
      this.useraddress = newAddress
    },
    save() {
      if (!this.$refs.form.validate()) {
        return this.$events.fire('showError', 'Formuläret är inte korrekt ifyllt.')
      }

      if (!this.wp.email) {
        this.wp.email = null
      }
      // Fire save event ,after getting the form modal submited
      // @arg The argument is object representing workplace data

      this.$emit('save', this.wp)
    },

    // @vuese
    //- Used to get all the  employements from the selected company and display data in table
    getDepartments() {
      this.departments = []
      API.listDepartments(this.selectedCompany.id)
        .then(response => {
          response.data.forEach(d => {
            this.departments.push({
              id: d.id,
              name: d.name ? d.name : ''
            })
          })
        })
        .catch(error => {
          console.log('get departments', error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.switch {
  font-size: 18px;
  font-weight: bold;
}
</style>